export default __webpack_public_path__ + "static/media/python-logo.82652884.svg";